import {Component, Input} from '@angular/core';
import {OnfidoCheck} from '../../../api/entity';


@Component({
    selector: 'tfl-bo-onfido-verification-check',
    template: `
        <accordion>
            <accordion-group>
                <accordion-header>
                    <accordion-toggle
                        title="{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.CHECK_ID' | translate }}: {{ check.checkId }}">
                    </accordion-toggle>
                </accordion-header>

                <accordion-content>
                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.CREATE_DATE_TIME' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">{{ check.createTime }}</div>
                    </div>
                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.COMPLETE_DATE_TIME' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">{{ check.completeTime }}</div>
                    </div>
                    <div class="row">
                        <div class="col-xs-3">
                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.HAS_ERRORS' | translate }}:</b>
                        </div>
                        <div class="col-xs-9">{{ check.hasErrors }}</div>
                    </div>

                    <h5>{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.REPORTS' | translate }}:</h5>

                    <div class="verification-results-block-inner" *ngFor="let report of check.reports">
                        <hr>
                        <tfl-bo-onfido-verification-report
                            [report]="report"></tfl-bo-onfido-verification-report>
                    </div>
                </accordion-content>
            </accordion-group>
        </accordion>
    `
})
export class CheckOnfidoVerificationComponent {

    @Input() check: OnfidoCheck;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/onfido/results/check.onfido.verification.component.ts